import React from 'react';
import InputField from '../../../Forms/Input/InputField';
import { usePurchaseInvalidation } from '../../../../hooks/purchases/invalidation/usePurchaseInvalidation';

const ReplacementPurchaseSelector: React.FC = () => {
  const { form, formErrors, updateField } = usePurchaseInvalidation();

  // 🔥 Normalizar tipo
  const type = String(form.invalidationTypeCode ?? '');

  // 🔥 Regla de negocio
  const isRequired = ['1', '3'].includes(type);

  return (
    <div className="w-full">
      <InputField
        label={`Código de Generación de la Compra de Reemplazo ${
          isRequired ? '(obligatorio)' : '(no aplica)'
        }`}
        name="replacementGenerationCode"
        value={form.replacementGenerationCode ?? ''}
        onChange={(e) =>
          updateField(
            'replacementGenerationCode',
            e.target.value.trim() || null // 🔥 normalización
          )
        }
        iconKey="hash"
        error={formErrors['replacementGenerationCode']}
        type="text"
        required={isRequired}          // 🔥 dinámico
        disabled={!isRequired}         // 🔥 bloquea cuando es tipo 2
        placeholder="664F9D1B-70DA-427D-93B5-C3C7C4B4B9C7"
      />
    </div>
  );
};

export default ReplacementPurchaseSelector;